import { Button } from "@mui/material";
import { getReadyServiceWorker, requestNotificationPermission, subscribeToPush } from "../services/notificationService";
import { setNotificationMessage, setShowNotification } from "../store";

export const AcceptNotifications = (props) => {

  const { setShowPopup, setIsSubscribed, isSupported } = props;

  const handleSubscribe = async () => {
    try {
      if (!isSupported) return;

      const granted = await requestNotificationPermission();
      if (!granted) {
        alert('Разрешение на уведомления не получено');
        return;
      }

      const swRegistration = await getReadyServiceWorker();
      await subscribeToPush(swRegistration);
      setIsSubscribed(true);
      setShowPopup();
    }
    catch (error) {
      console.error(error);
      setNotificationMessage(`Ошибка при подписке на уведомления! ${error.message}`);
      setShowNotification(true);
    }

  };

  return (
    <div className="accept-notifications">
      <h2>Аукцион в твоем кармане</h2>
      <p>Торгуйся где угодно! Разреши уведомления и участвуй в аукционе, даже когда не смотришь в телефон. Мгновенные оповещения не дадут соперникам обойти тебя.</p>
      <Button variant="contained" onClick={() => handleSubscribe()}>Включить уведомления</Button>
    </div>
  )
}